import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import breadcrumbProps from '../../propTypes/breadcrumbs';

const Breadcrumb = ({ baseUrl, breadcrumbs }) => (
  <ul className="sl-breadcrumbs">
    {breadcrumbs.map(breadcrumb => (
      <li key={breadcrumb.name}>
        <Link to={baseUrl ? `${baseUrl}${breadcrumb.url}` : breadcrumb.href}>
          {breadcrumb.name}
        </Link>
      </li>
    ))}
  </ul>
);

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(breadcrumbProps).isRequired,
  baseUrl: PropTypes.string,
};

Breadcrumb.defaultProps = {
  baseUrl: '',
};

export default Breadcrumb;
